module.exports = __webpack_public_path__ + "img/back-porch-wood-walk.07762cfe.webp";